import React, { FunctionComponent } from 'react';
import classnames from 'classnames';
import { MessageDescriptor, useIntl } from 'react-intl';

interface ErrorSpec {
  id: string;
  message: string;
  field?: string;
  timestamp?: number;
  args?: Record<string, unknown>;
}

export const TranslatedErrorMessage: FunctionComponent<{
  error: ErrorSpec;
}> = ({ error }) => {
  const intl = useIntl();

  return (
    <>
      {intl.formatMessage(
        { id: error.id, defaultMessage: error.message },

        // Translate values if necessary:
        Object.entries(error.args || {}).reduce((acc, [key, val]) => {
          acc[key] =
            typeof val === 'object'
              ? intl.formatMessage(val as MessageDescriptor)
              : val;

          return acc;
        }, {})
      )}
    </>
  );
};

const errorMessageClassNames = {
  'bg-red': true,
  'trade-gothic-bold': true,
  'f6': true,
  'pv2': true,
  'tc': true,
  'white': true,
};

const ErrorMessage: FunctionComponent<{ errors?: ErrorSpec[] | null }> = ({
  errors,
}) => {
  if (!errors?.length) return null;

  return (
    <>
      {errors
        .filter((error) => !error.field)
        .map((error) => (
          <div
            key={`error-${error.id}-${error.timestamp}`}
            className={classnames(errorMessageClassNames)}
          >
            {/* <span className="db">{getTranslatedErrorMessage(error)}</span> */}
            <span className="db">
              <TranslatedErrorMessage error={error} />
            </span>
          </div>
        ))}
    </>
  );
};

export default ErrorMessage;
